/* Suitality buyer AI, phase 1 (18 Oct 2026).
   1. Sentence search: a search of 3 words or more is turned into keywords, collection and filters by the Suitality service,
      then sent to the existing Shopify search. Short searches, errors, limits and timeouts fall back to the normal search.
   2. Venue advisor on 7 collections: the buyer describes the venue, the service picks 3 to 6 products of the collection
      with a reason taken from the product data.
   3. "Ask about this product": answered only from the product data; otherwise "Ask the supplier" opens the quote request.
   Loaded only when snippets/suitality-ai.liquid is switched on. No dependencies. */
(function () {
  'use strict';
  var cfgEl = document.getElementById('SAiConfig');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg || !cfg.endpoint) return;

  var params = new URLSearchParams(location.search);
  if (cfg.mode === 'preview') {
    try {
      if (params.get('ai') === '1') localStorage.setItem('suitality.ai.preview', '1');
      if (params.get('ai') === '0' && !params.get('q')) localStorage.removeItem('suitality.ai.preview');
      if (localStorage.getItem('suitality.ai.preview') !== '1') return;
    } catch (e) { return; }
  } else if (cfg.mode !== 'on') return;

  var END = cfg.endpoint.replace(/\/+$/, '');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function post(path, body, ms) {
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var t = ctrl ? setTimeout(function () { ctrl.abort(); }, ms || 8000) : null;
    return fetch(END + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      signal: ctrl ? ctrl.signal : undefined,
      credentials: 'omit'
    }).then(function (r) {
      if (t) clearTimeout(t);
      if (!r.ok) throw new Error('http ' + r.status);
      return r.json();
    });
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined) n.textContent = text;
    return n;
  }
  function words(s) { return String(s || '').trim().split(/\s+/).filter(Boolean); }
  function ss(k, v) {
    try {
      if (v === undefined) return JSON.parse(sessionStorage.getItem(k) || 'null');
      if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, JSON.stringify(v));
    } catch (e) { return null; }
  }
  var uid = 0;
  function id(p) { uid += 1; return 'sai-' + p + '-' + uid; }

  /* AI mark (18 Oct 2026): a 4-point star drawn as a line, same convention as the product file builder.
     Shown next to every Suitality AI feature, never as a badge. */
  var SVGNS = 'http://www.w3.org/2000/svg';
  function spark(label) {
    var s = document.createElementNS(SVGNS, 'svg');
    s.setAttribute('class', 's-ai-mark');
    s.setAttribute('viewBox', '0 0 16 16');
    s.setAttribute('width', '13');
    s.setAttribute('height', '13');
    s.setAttribute('focusable', 'false');
    if (label) { s.setAttribute('role', 'img'); s.setAttribute('aria-label', label); }
    else s.setAttribute('aria-hidden', 'true');
    var p = document.createElementNS(SVGNS, 'path');
    p.setAttribute('d', 'M8 1.5C8.6 5.4 10.6 7.4 14.5 8C10.6 8.6 8.6 10.6 8 14.5C7.4 10.6 5.4 8.6 1.5 8C5.4 7.4 7.4 5.4 8 1.5Z');
    p.setAttribute('fill', 'none');
    p.setAttribute('stroke', 'currentColor');
    p.setAttribute('stroke-width', '1.3');
    p.setAttribute('stroke-linejoin', 'round');
    s.appendChild(p);
    return s;
  }
  /* "✦ Suitality AI" style tag: mark + short text, 12px, muted */
  function aiTag(text) {
    var t = el('span', 's-ai-tag');
    t.appendChild(spark());
    t.appendChild(el('span', '', text));
    return t;
  }

  /* ------------------------------------------------------------ 1. sentence search */
  var collections = [];
  try { collections = JSON.parse((document.getElementById('SAiCollections') || {}).textContent || '[]'); } catch (e) { collections = []; }

  function searchUrl(q, extra) {
    var u = '/search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last';
    return u + (extra || '');
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.dataset.saiPass === '1') return;
    var action = form.getAttribute('action') || '';
    if (!/\/search\/?$/.test(action)) return;
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    var q = input.value.trim();
    if (words(q).length < 3) return; // short searches stay exactly as today
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.classList.add('s-ai-busy'); }
    form.setAttribute('aria-busy', 'true');

    function plain() {
      form.dataset.saiPass = '1';
      if (btn) { btn.removeAttribute('aria-busy'); btn.classList.remove('s-ai-busy'); }
      form.removeAttribute('aria-busy');
      ss('suitality.ai.search', null);
      form.submit();
    }

    post('/ai/search', { q: q, collections: collections }, 5000).then(function (r) {
      if (!r || (!r.keywords && !r.collection)) return plain();
      var extra = '';
      if (r.price_min != null) extra += '&filter.v.price.gte=' + encodeURIComponent(r.price_min);
      if (r.price_max != null) extra += '&filter.v.price.lte=' + encodeURIComponent(r.price_max);
      var target = r.keywords ? searchUrl(r.keywords, extra) : '/collections/' + encodeURIComponent(r.collection);
      ss('suitality.ai.search', {
        q: q, keywords: r.keywords || '', collection: r.collection || '', summary: r.summary || '',
        ship_to: r.ship_to || '', certifications: r.certifications || [], max_min_order: r.max_min_order, at: Date.now()
      });
      location.href = target;
    }).catch(plain);
  }, true);

  /* Search fields: new placeholder, and a one-line hint under the field while it has focus */
  function decorateSearch() {
    var forms = document.querySelectorAll('form[action$="/search"], form[action$="/search/"]');
    Array.prototype.forEach.call(forms, function (form) {
      var input = form.querySelector('input[name="q"]');
      if (!input || form.dataset.saiDeco === '1') return;
      form.dataset.saiDeco = '1';
      input.setAttribute('placeholder', 'Search products or describe what you need');
      var hid = id('search-hint');
      var hint = el('p', 's-ai-shint');
      hint.id = hid;
      hint.appendChild(spark('Suitality AI'));
      hint.appendChild(el('span', '', 'New: describe your venue in a sentence, e.g. “refillable amenities for a 120-room hotel”'));
      var desc = input.getAttribute('aria-describedby');
      input.setAttribute('aria-describedby', desc ? desc + ' ' + hid : hid);
      if (window.getComputedStyle(form).position === 'static') form.style.position = 'relative';
      form.appendChild(hint);
    });
  }

  function banner(host, info) {
    var box = el('div', 's-ai-note');
    box.setAttribute('role', 'status');
    if (info.fallback) box.appendChild(el('p', 's-ai-note__text s-ai-note__fallback', 'No product matches exactly. Here are some close options.'));
    var p = el('p', 's-ai-note__text');
    p.appendChild(spark('Suitality AI'));
    var understood = info.summary ? String(info.summary).replace(/^showing\s+/i, '') : ('“' + info.keywords + '”');
    p.appendChild(el('span', '', 'Understood as: ' + understood));
    box.appendChild(p);
    var notes = [];
    if (info.ship_to) notes.push('Delivery to ' + info.ship_to + ': check the delivery line on each product.');
    if (info.certifications && info.certifications.length) notes.push('Certification asked: ' + info.certifications.join(', ') + '. Check the specifications of each product.');
    if (info.max_min_order) notes.push('Minimum order up to ' + info.max_min_order + ': shown on each product.');
    notes.forEach(function (n) { box.appendChild(el('p', 's-ai-note__hint', n)); });
    var foot = el('p', 's-ai-note__foot');
    foot.appendChild(el('span', 's-ai-note__by', 'Suitality AI · '));
    var a = el('a', 's-ai-note__link', 'Search exactly “' + info.q + '”');
    a.href = searchUrl(info.q, '&ai=0');
    foot.appendChild(a);
    box.appendChild(foot);
    host.parentNode.insertBefore(box, host.nextSibling);
  }

  function logSearch(q, n, kind) {
    if (!q) return;
    try {
      var body = JSON.stringify({ q: q, results: n, kind: kind });
      if (navigator.sendBeacon) {
        navigator.sendBeacon(END + '/ai/log', new Blob([body], { type: 'text/plain' }));
      } else {
        post('/ai/log', { q: q, results: n, kind: kind }, 3000).catch(function () {});
      }
    } catch (e) {}
  }

  if (cfg.page === 'search' && cfg.search && cfg.search.performed) {
    var info = ss('suitality.ai.search');
    var head = document.querySelector('.s-search-page .s-coll__head') || document.querySelector('main h1');
    var fresh = info && info.keywords && Date.now() - info.at < 10 * 60 * 1000 &&
      String(cfg.search.terms || '').replace(/\*/g, '').trim().toLowerCase() === info.keywords.toLowerCase();
    if (fresh && head && params.get('ai') !== '0' && cfg.search.results === 0 && !(info.tries >= 2)) {
      /* Suitality AI always answers: no result, so retry once with the main keywords, then with the collection it chose */
      logSearch(info.q, 0, 'ai-search');
      info.tries = (info.tries || 0) + 1;
      info.fallback = true;
      info.at = Date.now();
      var kw = words(String(info.keywords || '').toLowerCase()).filter(function (w) { return w.length > 2; });
      if (info.tries === 1 && kw.length > 2) {
        info.keywords = kw.slice(0, 2).join(' ');
        ss('suitality.ai.search', info);
        location.replace(searchUrl(info.keywords));
      } else if (info.collection) {
        info.keywords = '';
        info.tries = 2;
        ss('suitality.ai.search', info);
        location.replace('/collections/' + encodeURIComponent(info.collection));
      } else if (kw.length > 1 && info.tries === 1) {
        info.keywords = kw[kw.length - 1];
        ss('suitality.ai.search', info);
        location.replace(searchUrl(info.keywords));
      } else {
        banner(head, info);
      }
    } else if (fresh && head && params.get('ai') !== '0') {
      banner(head, info);
      logSearch(info.q, cfg.search.results, 'ai-search');
    } else if (cfg.search.results === 0) {
      logSearch(String(cfg.search.terms || '').replace(/\*/g, ''), 0, 'search');
    }
  }
  if (cfg.page === 'collection' && params.get('ai') !== '0') {
    var ci = ss('suitality.ai.search');
    var ch = document.querySelector('.s-coll__head');
    if (ci && !ci.keywords && ci.collection && ch && location.pathname.indexOf('/collections/' + ci.collection) === 0 && Date.now() - ci.at < 10 * 60 * 1000) { banner(ch, ci); ss('suitality.ai.search', null); }
  }

  /* ------------------------------------------------------------ 2. venue advisor */
  function compact(p) {
    var v = (p.variants || [])[0] || {};
    var d = String(p.body_html || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 300);
    var tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',');
    return {
      h: p.handle, t: p.title, v: p.vendor, p: v.price || '', ty: p.product_type || '',
      tg: tags.map(function (s) { return String(s).trim(); }).filter(Boolean).slice(0, 15).join(', '), d: d,
      _img: (p.images && p.images[0] && p.images[0].src) || '', _id: p.id
    };
  }
  function score(p, ws) {
    var hay = (p.t + ' ' + p.ty + ' ' + p.tg + ' ' + p.v + ' ' + p.d).toLowerCase();
    var title = p.t.toLowerCase();
    var toks = hay.split(/[^a-z0-9À-ɏ]+/).filter(function (x) { return x.length > 3; });
    var s = 0;
    ws.forEach(function (w) {
      if (w.length < 3) return;
      var stem = w.replace(/(ies)$/, 'y').replace(/(es|s)$/, '');
      var hit = hay.indexOf(w) > -1 || (stem.length > 2 && hay.indexOf(stem) > -1);
      if (!hit && w.length > 6) hit = toks.some(function (x) { return w.indexOf(x) > -1; });
      if (!hit) return;
      s += (title.indexOf(stem) > -1 || title.indexOf(w) > -1) ? 3 : 1;
    });
    return s;
  }
  function loadProducts(handle) {
    var all = [];
    function page(n) {
      return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) {
          var list = (j && j.products) || [];
          all = all.concat(list);
          if (list.length === 250 && n < 2) return page(n + 1);
          return all;
        });
    }
    return page(1);
  }
  function imgUrl(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function money(v) {
    var n = parseFloat(v);
    if (!isFinite(n)) return '';
    return '€' + n.toFixed(2);
  }

  function advisor() {
    if (!cfg.advise) return;
    var anchor = document.querySelector('.s-coll [data-sb-top]') || document.querySelector('.s-coll__layout');
    if (!anchor) return;
    var sec = el('section', 's-ai-adv');
    var hid = id('adv-h');
    sec.setAttribute('aria-labelledby', hid);
    var head = el('div', 's-ai-adv__head');
    var h = el('h2', 's-ai-adv__title', 'Venue advisor');
    h.id = hid;
    head.appendChild(h);
    var tag = aiTag('Suitality AI');
    tag.querySelector('svg').setAttribute('role', 'img');
    tag.querySelector('svg').setAttribute('aria-label', 'Suitality AI');
    tag.querySelector('svg').removeAttribute('aria-hidden');
    tag.lastChild.setAttribute('aria-hidden', 'true');
    head.appendChild(tag);
    var pid = id('adv-how');
    var how = el('button', 's-ai-how', 'How it works');
    how.type = 'button';
    how.setAttribute('aria-expanded', 'false');
    how.setAttribute('aria-controls', pid);
    var tip = el('p', 's-ai-tip', 'Suggestions come only from supplier product data on Suitality. Check details on each product.');
    tip.id = pid;
    tip.hidden = true;
    function setTip(open) { tip.hidden = !open; how.setAttribute('aria-expanded', open ? 'true' : 'false'); }
    how.addEventListener('click', function () { setTip(tip.hidden); });
    how.addEventListener('keydown', function (e) { if (e.key === 'Escape') setTip(false); });
    document.addEventListener('click', function (e) { if (!tip.hidden && e.target !== how && !tip.contains(e.target)) setTip(false); });
    var howWrap = el('span', 's-ai-howwrap');
    howWrap.appendChild(how);
    howWrap.appendChild(tip);
    head.appendChild(howWrap);
    sec.appendChild(head);
    var form = el('form', 's-ai-adv__form');
    form.setAttribute('novalidate', '');
    var fid = id('adv-q');
    var label = el('label', 's-ai-adv__label', 'Describe your venue and what you need');
    label.setAttribute('for', fid);
    var row = el('div', 's-ai-row');
    var ta = el('textarea', 's-ai-input');
    ta.id = fid; ta.rows = 2; ta.maxLength = 400;
    ta.placeholder = 'For example: 80-room boutique hotel, refillable products, delivery to Italy';
    var btn = el('button', 'btn', 'Show matching products');
    btn.type = 'submit';
    row.appendChild(ta); row.appendChild(btn);
    var hint = el('p', 's-ai-hint', 'The selection uses only the information on the products of ' + cfg.advise.title + '.');
    var out = el('div', 's-ai-adv__out');
    out.setAttribute('aria-live', 'polite');
    form.appendChild(label); form.appendChild(row); form.appendChild(hint);
    sec.appendChild(form); sec.appendChild(out);
    anchor.parentNode.insertBefore(sec, anchor);

    ta.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); form.requestSubmit ? form.requestSubmit() : btn.click(); }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var need = ta.value.trim();
      if (need.length < 6) { out.textContent = ''; out.appendChild(el('p', 's-ai-msg', 'Add a few words about the venue and the products you need.')); ta.focus(); return; }
      btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.classList.add('s-ai-busy');
      out.textContent = '';
      out.appendChild(el('p', 's-ai-msg', 'Looking through ' + cfg.advise.title + '…'));
      var byHandle = {};
      var pool = [];
      loadProducts(cfg.advise.handle).then(function (list) {
        var ws = words(need.toLowerCase().replace(/[^\p{L}\p{N}\s]/gu, ' '));
        var items = list.map(compact);
        items.forEach(function (p) { byHandle[p.h] = p; p._s = score(p, ws); });
        var ranked = items.slice().sort(function (a, b) { return b._s - a._s; }).slice(0, 60);
        pool = ranked;
        var send = ranked.map(function (p) { return { h: p.h, t: p.t, v: p.v, p: p.p, ty: p.ty, tg: p.tg, d: p.d }; });
        return post('/ai/advise', { collection: cfg.advise.title, need: need, products: send }, 15000);
      }).then(function (r) {
        renderPicks(out, r, byHandle, need, pool);
      }).catch(function () {
        if (pool.length) { renderPicks(out, null, byHandle, need, pool); return; }
        out.textContent = '';
        out.appendChild(el('p', 's-ai-msg', 'The selection is not available right now. Use the filters below, or send us your request.'));
        var a = el('a', 'btn btn--secondary', 'Request a quote');
        a.href = '/pages/request-for-quote#quote';
        out.appendChild(a);
      }).then(function () {
        btn.disabled = false; btn.removeAttribute('aria-busy'); btn.classList.remove('s-ai-busy');
      });
    });
  }

  function renderPicks(out, r, byHandle, need, pool) {
    out.textContent = '';
    var picks = (r && r.picks || []).filter(function (x) { return byHandle[x.h]; });
    if (!picks.length) {
      /* Suitality AI always answers: close options from the collection, ranked by the local score, no invented reason */
      logSearch(need, 0, 'advise');
      picks = (pool || []).filter(function (p) { return p._img && parseFloat(p.p) > 0; }).slice(0, 6)
        .map(function (p) { return { h: p.h, reason: '' }; });
      if (picks.length) out.appendChild(el('p', 's-ai-msg', 'No product matches exactly. Here are some close options:'));
      else out.appendChild(el('p', 's-ai-msg', 'No product matches exactly. Browse the products below, or send us your request.'));
    } else if (r && r.summary) {
      out.appendChild(el('p', 's-ai-msg', r.summary));
    }
    if (picks.length) {
      var grid = el('ul', 's-ai-picks');
      picks.forEach(function (x, i) {
        var p = byHandle[x.h];
        var li = el('li', 's-ai-pick');
        if (!reduce) li.style.animationDelay = (i * 40) + 'ms';
        var a = el('a', 's-ai-pick__link');
        a.href = '/products/' + encodeURIComponent(p.h);
        var fig = el('span', 's-ai-pick__img');
        if (p._img) {
          var im = el('img');
          im.src = imgUrl(p._img, 240); im.alt = p.t; im.loading = 'lazy'; im.width = 120; im.height = 120;
          fig.appendChild(im);
        }
        a.appendChild(fig);
        var txt = el('span', 's-ai-pick__txt');
        txt.appendChild(el('span', 's-ai-pick__vendor', p.v));
        txt.appendChild(el('span', 's-ai-pick__title', p.t));
        if (p.p) txt.appendChild(el('span', 's-ai-pick__price', money(p.p) + ' excl. VAT'));
        a.appendChild(txt);
        li.appendChild(a);
        if (x.reason) li.appendChild(el('p', 's-ai-pick__why', x.reason));
        grid.appendChild(li);
      });
      out.appendChild(grid);
    }
    if (r && r.questions && r.questions.length) {
      var q = el('div', 's-ai-qs');
      q.appendChild(el('p', 's-ai-qs__h', 'To narrow it down, add to your description:'));
      var ul = el('ul');
      r.questions.forEach(function (s) { ul.appendChild(el('li', '', s)); });
      q.appendChild(ul);
      out.appendChild(q);
    }
  }

  /* ------------------------------------------------------------ 3. ask about this product */
  function specsFromPage() {
    var pairs = [], seen = {};
    var dts = document.querySelectorAll('.s-specs__table dt, .s-pdp2-below dl dt, .s-pdp2-buy dl dt');
    Array.prototype.forEach.call(dts, function (dt) {
      var dd = dt.nextElementSibling;
      if (!dd || dd.tagName !== 'DD') return;
      var k = dt.textContent.trim(), v = dd.textContent.trim();
      var key = (k + '|' + v).toLowerCase();
      if (!k || !v || seen[key]) return;
      seen[key] = 1; pairs.push([k, v]);
    });
    return pairs.slice(0, 60);
  }

  function askBox() {
    var pr = cfg.product;
    if (!pr) return;
    var box = el('div', 's-ai-ask');
    var fid = id('ask-q');
    var labelRow = el('div', 's-ai-ask__head');
    var label = el('label', 's-ai-ask__label', 'Ask about this product');
    label.setAttribute('for', fid);
    labelRow.appendChild(label);
    var askTag = aiTag('Answers from this listing · Suitality AI');
    var tagId = id('ask-tag');
    askTag.id = tagId;
    labelRow.appendChild(askTag);
    var form = el('form', 's-ai-row');
    form.setAttribute('novalidate', '');
    var input = el('input', 's-ai-input');
    input.type = 'text'; input.id = fid; input.maxLength = 300; input.autocomplete = 'off';
    input.placeholder = 'For example: what is the carton size?';
    input.setAttribute('aria-describedby', tagId);
    var btn = el('button', 'btn btn--secondary', 'Ask');
    btn.type = 'submit';
    form.appendChild(input); form.appendChild(btn);
    var out = el('div', 's-ai-ask__out');
    out.setAttribute('aria-live', 'polite');
    box.appendChild(labelRow); box.appendChild(form); box.appendChild(out);

    function place() {
      var short = document.querySelector('[data-s-pdp2-short]');
      var below = document.querySelector('[data-s-pdp2-below]');
      if (short && below && !below.hidden) { short.appendChild(box); return true; }
      return false;
    }
    if (!place()) {
      var tries = 0;
      var iv = setInterval(function () {
        tries += 1;
        if (place() || tries > 20) {
          clearInterval(iv);
          if (!box.parentNode) {
            var main = document.querySelector('#MainContent .s-pdp2-below, #MainContent');
            if (main) main.appendChild(box);
          }
        }
      }, 150);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = input.value.trim();
      if (q.length < 4) { input.focus(); return; }
      btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.classList.add('s-ai-busy');
      out.textContent = '';
      out.appendChild(el('p', 's-ai-msg', 'Reading the product page…'));
      var body = {
        question: q,
        product: {
          handle: pr.handle, title: pr.title, vendor: pr.vendor, type: pr.type, tags: pr.tags,
          description: pr.description, variants: pr.variants, specs: specsFromPage()
        }
      };
      post('/ai/ask', body, 10000).then(function (r) {
        out.textContent = '';
        var ans = el('div', 's-ai-answer' + (r.found ? '' : ' s-ai-answer--none'));
        ans.appendChild(el('p', 's-ai-answer__text', r.answer || 'The product page does not say.'));
        if (r.found && r.source) ans.appendChild(el('p', 's-ai-answer__src', 'From the product ' + r.source + '.'));
        if (!r.found) supplierButton(ans, q);
        out.appendChild(ans);
      }).catch(function () {
        out.textContent = '';
        var ans = el('div', 's-ai-answer s-ai-answer--none');
        ans.appendChild(el('p', 's-ai-answer__text', 'The answer is not available right now. You can ask the supplier directly.'));
        supplierButton(ans, q);
        out.appendChild(ans);
      }).then(function () {
        btn.disabled = false; btn.removeAttribute('aria-busy'); btn.classList.remove('s-ai-busy');
      });
    });
  }

  function supplierButton(host, q) {
    var pr = cfg.product;
    var b = el('button', 'btn btn--secondary s-ai-answer__btn', 'Ask the supplier');
    b.type = 'button';
    b.addEventListener('click', function () {
      try {
        if (window.SuitalityQuote) {
          window.SuitalityQuote.add({ id: pr.variant, handle: pr.handle, title: pr.title, vendor: pr.vendor, img: pr.img, url: pr.url, qty: 1 });
        }
      } catch (e) {}
      ss('suitality.ai.ask', { title: pr.title, q: q });
      location.href = '/pages/request-for-quote?from=quote#quote';
    });
    host.appendChild(b);
  }

  /* On the quote request page: put the question in the message field once */
  function prefillQuote() {
    var a = ss('suitality.ai.ask');
    if (!a) return;
    var fields = document.querySelectorAll('form textarea');
    var target = null;
    Array.prototype.forEach.call(fields, function (t) {
      var n = (t.name || '') + ' ' + (t.id || '');
      if (!target && /message|details|request/i.test(n) && !t.value) target = t;
    });
    if (!target) return;
    target.value = 'Question about ' + a.title + ': ' + a.q;
    ss('suitality.ai.ask', null);
  }

  function start() {
    decorateSearch();
    if (cfg.page === 'collection') advisor();
    if (cfg.page === 'product') askBox();
    if (/request-for-quote/.test(location.pathname)) prefillQuote();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
